import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS } from '../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/frontier-exposure-analysis/')({
  beforeLoad: ({ context, preload }) => {
    const { validatePermissions, userPermissions } = context;
    const isAllowed = !!userPermissions.hasAllowedPermission({ path: PAGE_PATHS.FREA_SETTINGS });
    validatePermissions({ isAllowed, preload });
  },
});
